import { render } from "./DataLoading.vue?vue&type=template&id=299432d3"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__